import { Injectable } from '@angular/core';
import { WrapperErrorListModel } from 'wrapper-error-list';
import { BehaviorSubject, map } from 'rxjs';
import {
  configs,
  passwordValidations,
} from 'src/domains/site-managment/feature/system-config-ddd/domain-layer/entity/configs-options.entity';
import { ConfigsApplication } from 'src/domains/site-managment/feature/system-config-ddd/application-layer/service/configs.application';
@Injectable({
  providedIn: 'root',
})
export class CheckPasswordService {
  private static config = new BehaviorSubject<
    Map<passwordValidations, WrapperErrorListModel.validation>
  >(new Map());

  static get config$() {
    return this.config;
  }

  constructor(private systemConfigApplication: ConfigsApplication) {
    this.checkValidations();
  }
  checkValidations() {
    CheckPasswordService.config
      .pipe(
        map((configs) => {
          if (configs.size == 0) {
            this.systemConfigApplication.getConfigsValue().subscribe((res) => {
              const conditions: configs = res.configs;
              conditions.digit &&
                configs.set('digits', {
                  validate: /\d/,
                  text: `شامل اعداد باشد`,
                });
              conditions.lowercase &&
                configs.set('lowercase', {
                  validate: /[a-z]/,
                  text: `شامل حروف کوچک باشد. `,
                });
              conditions.uppercase &&
                configs.set('uppercase', {
                  validate: /[A-Z]/,
                  text: `شامل حروف بزرگ باشد`,
                });
              configs.set('minlength', {
                validate: new RegExp(`^.{${conditions.minLength},}$`),
                text: `حداقل دارای ${conditions.minLength}کاراکتر باشد`,
              });
              conditions.specialChar &&
                configs.set('symbols', {
                  validate: /[!@#$%^&*(),.?":{}|<>]/,
                  text: `شامل کاراکترهای خاص باشد`,
                });
              CheckPasswordService.config.next(configs);
            });
          }
        }),
      )
      .subscribe();
  }
}
